import { useAtom } from 'jotai';
import {
    Drawer,
    DrawerContent,
    DrawerDescription,
    DrawerHeader,
    DrawerTitle,
} from '@rocco/components/drawer';
import { EditBuildHubForm } from './EditBuildHubForm';
import { uiStateAtomEditBuildHubModal } from './edit-modal-state';

export const EditBuildHubModal = () => {
    const [uiState, setUiState] = useAtom(uiStateAtomEditBuildHubModal);

    return (
        <Drawer
            open={uiState.isOpen}
            onOpenChange={(open) => {
                setUiState({ ...uiState, isOpen: open });
            }}
            direction="right"
        >
            <DrawerContent
                className="data-[vaul-drawer-direction=right]:sm:max-w-[40rem]"
                variant="default"
                overlayVariant="dark"
                noHandle={true}
                scrollable={true}
            >
                <DrawerHeader className="hidden" aria-hidden>
                    {/* Supress missing title/description console warning */}
                    <DrawerTitle className="hidden" aria-hidden>
                        Edit Project
                    </DrawerTitle>
                    <DrawerDescription className="hidden" aria-hidden />
                </DrawerHeader>
                <div className="px-6 py-4 md:px-8 md:py-8">
                    <EditBuildHubForm buildHubId={uiState.buildHubId} />
                </div>
            </DrawerContent>
        </Drawer>
    );
};
